import '../styles/App.scss';
function Porto() {
  return (
    <div className="container-content">
      <div className="head">
        {/* <p className="title">{dataz}</p> */}
      </div>
      <div className="projects">
        <p className='subtitle'>Professional Experiences</p>
        <div className="item">
          <div className="info">
            <a href="https://www.linkedin.com/company/hope-services/" target="_blank" rel="noreferrer">
              <p className="name">Clinical Data Scientist Intern at Hope Services</p>
            </a>
            <p className="description">
              June 2025 - August 2025
            </p>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/hope-services/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://media.licdn.com/dms/image/v2/C4E0BAQEZKS8UnlgrlA/company-logo_200_200/company-logo_200_200/0/1630608830788/hope_services_logo?e=2147483647&v=beta&t=0FX5xZEP7Vlr6KeyqdCzphD-pUpvtivI8w1gsrhrS68' alt='logo'/>
            </a>
          </div>
        </div>
        <div className="item">
          <div className="info">
            <a href="https://www.linkedin.com/company/telkomsel/" target="_blank" rel="noreferrer">
              <p className="name">Data Scientist (Analytics) at Telkomsel</p>
            </a>
            <p className="description">
              January 2022 - July 2024
            </p>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/telkomsel/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://upload.wikimedia.org/wikipedia/commons/b/bc/Telkomsel_2021_icon.svg' alt='logo'/>
            </a>
          </div>
        </div>
        <div className="item">
          <div className="info">
            <a href="https://www.linkedin.com/company/pt-tokopedia/" target="_blank" rel="noreferrer">
              <p className="name">Data Analyst at GoTo </p>
            </a>
            <p className="description">
              September 2020 - November 2021
            </p>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/pt-tokopedia/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://www.freepnglogos.com/uploads/logo-tokopedia-png/berita-tokopedia-info-berita-terbaru-tokopedia-6.png' alt='logo'/>
            </a>
          </div>
        </div>
        <div className="item">
          <div className="info">
            <a href="https://www.linkedin.com/company/akseleran/" target="_blank" rel="noreferrer">
              <p className="name">Risk Analyst Intern at Akseleran P2P Fintech </p>
            </a>
            <p className="description">
              January 2020 - August 2020
            </p>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/akseleran/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://www.bikincv.com/blog/wp-content/uploads/2020/08/Logo-Akseleran-768x512.jpg' alt='logo'/>
            </a>
          </div>
        </div>
        <div className="item">
          <div className="info">
            <a href="https://www.linkedin.com/company/indonesia-stock-exchange/" target="_blank" rel="noreferrer">
              <p className="name">Data Analyst Intern at Indonesia Stock Exchange </p>
            </a>
            <p className="description">
              June 2019 - September 2019
            </p>
          </div>
          <div>
            <a href="https://www.linkedin.com/company/indonesia-stock-exchange/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://upload.wikimedia.org/wikipedia/commons/c/cb/IDX_Channel.png' alt='logo'/>
            </a>
          </div>
        </div>
        <p className='subtitle'>Educations</p>
        <div className="item">
          <div className="info">
            <a href="https://viterbischool.usc.edu/" target="_blank" rel="noreferrer">
              <p className="name">MS in Applied Data Science, USC Viterbi School of Engineering</p>
            </a>
            <p className="description">
              August 2024 - May 2026
            </p>
          </div>
          <div>
            <a href="https://viterbischool.usc.edu/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://viterbischool.usc.edu/wp-content/uploads/2017/11/main_university.jpg' alt='logo'/>  
            </a>
          </div>
        </div>
        <div className="item">
          <div className="info">
            <a href="https://www.ui.ac.id/en/" target="_blank" rel="noreferrer">
              <p className="name">BSc Statistics, University of Indonesia</p>
            </a>
            <p className="description">
              September 2016 - August 2020
            </p>
          </div>
          <div>
            <a href="https://www.ui.ac.id/en/" target="_blank" rel="noreferrer">
              <img className='logo-item' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPjt54Np-03xeUM_fAtKZ-RZ-IYUlXUWs_qQ&s' alt='logo'/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Porto;
